// 权限文件

import Cookies from 'js-cookie'
import router from './router'
import store from './store'
import { getToken, setToken } from './utils/auth.js'
import getPageTitle from './utils/get-page-title.js'
import { getIndexGuideApi } from '@/api/start'

// 白名单
const whiteList = ['/login', '/splashscreen', '/success', '/register', '/agreement', '/policy', '/forgot', '/reset']

// 全局前置守卫

router.beforeEach(async (to, from, next) => {
  document.title = getPageTitle(to.meta.title)
  const hasToken = getToken()
  if (hasToken) {
    // 如果有Token
    // 如果去登录页或者启动页，则强制跳转到首页
    if (to.path == '/login' || to.path == '/splashscreen') {
      next({ path: '/' })
    } else {
      next()
    }
  } else {
    // has no token 如果没有token
    // 如果在白名单内就正常放行
    if (whiteList.indexOf(to.path) !== -1) {
      if (to.path == '/success') {
        if (!!to.query.token) {
          setToken(to.query.token)
          store.commit('user/SET_TOKEN', to.query.token)
          Cookies.set('success-orderNo', to.query.orderNo)
          store.dispatch('user/getInfo')
          Cookies.set('test', 'test2')
          next()
        }
        next()
      } else {
        next()
      }
    } else {
      if (to.path == '/') {
        const res = await getIndexGuideApi(to.query.code)
        // const res = await getIndexGuideApi('C202509001')
        const opPicUrl = res.data
        if (!!opPicUrl) {
          store.commit('user/SET_OPPICURL', opPicUrl)
          next('/splashscreen')
        } else {
          next('/login')
        }
      } else {
        next('/')
      }
    }
  }
})
